//=================================================
//    summary: DCP ToolBarBottomUnit -- Hook
//
//    remarks: 000 Tim 2021/11/03 Create
//================================================
import React, { useState, useEffect } from 'react'
import cssToolBarBottomUnit from './ToolBarBottomUnit.module.scss'

// // 準備移除 App 取得資料 流程   Tim22.08.09
// import * as AppDataAccess from '../../Utils/AppDataAccess'

import Resource from '../Resource/Resource'
import Glossary from '../Glossary/Glossary'
import NoteList from '../NoteList/NoteList'
import Settings from '../Settings/Settings'
import {GlobalLibs, RoutePathLibs} from 'bc-react-package'


// #region Member Variables
let mblnInitialized = false

let mobjShowComponentParam = null
// #endregion Member Variables


const COMP_NAME = "ToolBarBottomUnit"

function ToolBarBottomUnit(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    const [isShowResource, setIsShowResource] = useState(false)
    const [isShowNoteList, setIsShowNoteList] = useState(false)
    const [isShowGlossary, setIsShowGlossary] = useState(false)
    const [isShowSettings, setIsShowSettings] = useState(false)

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        RegisterOpenSettings()

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            mblnInitialized = false
            mobjShowComponentParam = null

            setIsShowSettings(false)
            setIsShowGlossary(false)
            setIsShowNoteList(false)
            setIsShowResource(false)
        }
    }, [props.History])


    // #region OnTapHandler
    /*===========================================
    summary: Home按鈕 處理
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function HomeOnTapHandler(event)
    {
        console.log(COMP_NAME + ".HomeOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (props.ButtonType !== window.gButtonTypeEnum.Home)
        {
            RoutePathLibs.Route2Path(props.History, "/Home")
        }
    } // end of HomeOnTapHandler

    /*===========================================
    summary: Lessons按鈕 處理
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function LessonsOnTapHandler(event)
    {
        console.log(COMP_NAME + ".LessonsOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (props.ButtonType !== window.gButtonTypeEnum.Lessons)
        {
            RoutePathLibs.Route2Path(props.History, "/Lessons")
        }
    } // end of LessonsOnTapHandler

    /*===========================================
    summary: Assessments按鈕 處理
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function AssessmentsOnTapHandler(event)
    {
        console.log(COMP_NAME + ".AssessmentsOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof (props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "AssessmentsOnTap"
            }

            props.CallbackRef(objCallbackData)
        }
    } // end of AssessmentsOnTapHandler

    /*===========================================
    summary: BCApps按鈕 處理
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function BCAppsOnTapHandler(event)
    {
        console.log(COMP_NAME + ".BCAppsOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof (props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "BCAppsOnTap"
            }

            props.CallbackRef(objCallbackData)
        }
    } // end of BCAppsOnTapHandler

    /*===========================================
    summary: Resources按鈕 處理
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ResourcesOnTapHandler(event)
    {
        console.log(COMP_NAME + ".ResourcesOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (props.ButtonType === window.gButtonTypeEnum.Prelude) ||
            (props.ButtonType === window.gButtonTypeEnum.LearningUnit)
            )
        {
            if (
                (typeof (props.CallbackRef) !== 'undefined') &&
                (props.CallbackRef !== null)
                )
            {
                let objCallbackData = {
                    "Action": "OpenShowResource",
                    "LessonID": props.LessonID,
                    "LUCatSeqNo": props.LUCatSeqNo
                }

                props.CallbackRef(objCallbackData)
            }
        }
        else
        {
            setIsShowResource(true)
        }
    } // end of ResourcesOnTapHandler

    /*===========================================
    summary: NoteList按鈕 處理
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function NoteListOnTapHandler(event)
    {
        console.log(COMP_NAME + ".NoteListOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (props.ButtonType === window.gButtonTypeEnum.Prelude) ||
            (props.ButtonType === window.gButtonTypeEnum.LearningUnit)
            )
        {
            if (
                (typeof (props.CallbackRef) !== 'undefined') &&
                (props.CallbackRef !== null)
                )
            {
                let objCallbackData = {
                    "Action": "OpenShowNoteList"
                }

                props.CallbackRef(objCallbackData)
            }
        }
        else
        {
            setIsShowNoteList(true)
        }
    } // end of NoteListOnTapHandler

    /*===========================================
    summary: Glossary按鈕 處理
    remarks: 000 Tim 2021/11/04 Create
             001 Tim 2022/08/09 註解 App 取得資料 流程
    ===========================================*/
    function GlossaryOnTapHandler(event)
    {
        console.log(COMP_NAME + ".GlossaryOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // // 準備移除 App 取得資料 流程   Tim22.08.09
        // if (window.gSession.App.InApp)
        // {
        //     GetGlossaryFromAppProcessBegin(window.gSession.App.BookCatID)
        // }
        // else
        // {
        if (
            (props.ButtonType === window.gButtonTypeEnum.Prelude) ||
            (props.ButtonType === window.gButtonTypeEnum.LearningUnit)
            )
        {
            if (
                (typeof (props.CallbackRef) !== 'undefined') &&
                (props.CallbackRef !== null)
                )
            {
                let objCallbackData = {
                    "Action": "OpenShowGlossary"
                }

                props.CallbackRef(objCallbackData)
            }
        }
        else
        {
            setIsShowGlossary(true)
        }
        // }
    } // end of GlossaryOnTapHandler

    /*===========================================
    summary: Settings按鈕 處理
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function SettingsOnTapHandler(event)
    {
        console.log(COMP_NAME + ".SettingsOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (props.ButtonType === window.gButtonTypeEnum.Prelude) ||
            (props.ButtonType === window.gButtonTypeEnum.LearningUnit)
            )
        {
            if (
                (typeof (props.CallbackRef) !== 'undefined') &&
                (props.CallbackRef !== null)
                )
            {
                let objCallbackData = {
                    "Action": "OpenShowSettings"
                }

                props.CallbackRef(objCallbackData)
            }
        }
        else
        {
            mobjShowComponentParam = {
                "AuthorizedSubscription": null
            }
            setIsShowSettings(true)
        }
    } // end of SettingsOnTapHandler

    /*===========================================
    summary: Help按鈕 處理
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function HelpOnTapHandler(event)
    {
        console.log(COMP_NAME + ".HelpOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof (props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "HelpOnTap"
            }

            props.CallbackRef(objCallbackData)
        }
    } // end of HelpOnTapHandler
    // #endregion OnTapHandler

    // #region ComponentCallback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowResource")
        {
            mobjShowComponentParam = null
            setIsShowResource(false)
        }
        else if (CallbackObj.Action === "CloseShowGlossary")
        {
            mobjShowComponentParam = null
            setIsShowGlossary(false)
        }
        else if (CallbackObj.Action === "CloseShowNoteList")
        {
            mobjShowComponentParam = null
            setIsShowNoteList(false)
        }
        else if (CallbackObj.Action === "CloseShowSettings")
        {
            mobjShowComponentParam = null
            setIsShowSettings(false)

            // CallbackObj.SettingsDirty = {
            //     // "ProfileEdit": false,
            //     // "PasswordChang": false,
            //     // "SubscriptionUpdate": false,
            //     "LangChange": false
            // }
            let objCallbackData = {
                "Action": "SettingsDirty",
                "SettingsDirty": CallbackObj.SettingsDirty
            }

            props.CallbackRef(objCallbackData)
        }
        else if (CallbackObj.Action === "GoToLearningUnit4Settings")
        {
            mobjShowComponentParam = null
            setIsShowSettings(false)

            GotoLearningUnit(CallbackObj.LocationState.BookSeqNo
                , CallbackObj.LocationState.LessonID
                , CallbackObj.LocationState.LUCatSeqNo)
        }
        else if (CallbackObj.Action === "GoToLearningUnit")
        {
            let objCallbackData = {
                "Action": "GoToLearningUnit",
                "LocationState": CallbackObj.LocationState
            }
            props.CallbackRef(objCallbackData)
        }
        else if (CallbackObj.Action === "OpenSettings4NoAuthorized")
        {
            mobjShowComponentParam = {
                "AuthorizedSubscription": CallbackObj.AuthorizedSubscription
            }
            setIsShowSettings(true)
            setIsShowGlossary(false)
            setIsShowNoteList(false)
            setIsShowResource(false)
        }
        else if (CallbackObj.Action === "OpenShowResource4NoAuthorized")
        {
            mobjShowComponentParam = null
            setIsShowSettings(false)
            setIsShowResource(true)
        }
        else if (CallbackObj.Action === "AssignReport4NoAuthorized")
        {
            mobjShowComponentParam = null
            setIsShowSettings(false)

            let objCallbackData = {
                "Action": "AssignReport4NoAuthorized"
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // // 準備移除 App 取得資料 流程   Tim22.08.09
    // // #region ComponentFuncEntry
    // /*===========================================
    // summary: 接回 Glossary Call AppDataAccess 的 入口
    // remarks: 000 Tim 2021/11/04 Create
    // ===========================================*/
    // function ComponentFuncEntry (CallObject)
    // {
    //     console.log(COMP_NAME + ".ComponentFuncEntry: ", CallObject)

    //     if (CallObject.Func === "GetGlossaryFromAppProcessEnd")
    //     {
    //         GetGlossaryFromAppProcessEnd()
    //     }
    //     else if (CallObject.Func === "GetGlossaryFromAppProcessError")
    //     {
    //         let objCallbackData = {
    //             "Action": "GetGlossaryFromAppProcessError",
    //             "ErrMsg": CallObject.ErrMsg
    //         }

    //         props.CallbackRef(objCallbackData)
    //     }
    //     else
    //     {
    //         console.log("unspported func: ", CallObject.Func)
    //     }
    // } // end of ComponentFuncEntry
    // // #endregion ComponentFuncEntry

    // #region Other Functions
    /*===========================================
    summary: 註冊 打開 設定視窗
    remarks: 000 Tim 2021/11/29 Create
    ===========================================*/
    function RegisterOpenSettings()
    {
        let objCallbackData = {
            "Action": "RegisterOpenSettings",
            "Function": OpenSettings
        }

        props.CallbackRef(objCallbackData)
    } // end of RegisterOpenSettings

    /*===========================================
    summary: 打開 設定視窗
    remarks: 000 Tim 2021/11/29 Create
    ===========================================*/
    function OpenSettings(AuthorizedSubscription)
    {
        console.log(COMP_NAME + ".OpenSettings AuthorizedSubscription: ", AuthorizedSubscription)

        if (
            (props.ButtonType === window.gButtonTypeEnum.Prelude) ||
            (props.ButtonType === window.gButtonTypeEnum.LearningUnit)
            )
        {
            if (
                (typeof (props.CallbackRef) !== 'undefined') &&
                (props.CallbackRef !== null)
                )
            {
                let objCallbackData = {
                    "Action": "OpenShowSettings"
                }

                props.CallbackRef(objCallbackData)
            }
        }
        else
        {
            mobjShowComponentParam = {
                "AuthorizedSubscription": AuthorizedSubscription
            }
            setIsShowSettings(true)
        }
    } // end of OpenSettings

    /*===========================================
    summary: 前往 LU的 連結
    remarks: 000 Tim 2021/11/29 Create
    ===========================================*/
    function GotoLearningUnit(BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GotoLearningUnit: ", BookSeqNo, LessonID, LUCatSeqNo)

        // 補 需要判斷 授權 是否可以進去 LU
        // -> Lessons

        let strLessonID = LessonID.PadLeft(5)
        let objLocationState = {
            "BookSeqNo": BookSeqNo,
            "LessonID": strLessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo)
        }

        if (props.ButtonType !== window.gButtonTypeEnum.Lessons)
        {
            RoutePathLibs.Route2Path(props.History, "/Lessons", objLocationState)
        }
        else
        {
            let objCallbackData = {
                "Action": "GoToLearningUnit",
                "LocationState": objLocationState
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of GotoLearningUnit
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 Lessons Line Cls
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function GetLessonsLineCls(PropsButtonType)
    {
        let objCls = ""

        if (PropsButtonType === window.gButtonTypeEnum.Lessons)
        {
            objCls = cssToolBarBottomUnit.btnLineDisabled
        }
        else
        {
            objCls = cssToolBarBottomUnit.btnLine
        }

        return objCls
    } // end of GetLessonsLineCls

    /*===========================================
    summary: 取得 Home Line Cls
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function GetHomeLineCls(PropsButtonType)
    {
        let objCls = ""

        if (
            (PropsButtonType === window.gButtonTypeEnum.LearningUnit) ||
            (PropsButtonType === window.gButtonTypeEnum.Prelude)
            )
        {
            objCls = cssToolBarBottomUnit.btnLine
        }
        else
        {
            objCls = cssToolBarBottomUnit.btnLineDisabled
        }

        return objCls
    } // end of GetHomeLineCls

    /*===========================================
    summary: 取得 大按鈕的 Cls
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function GetBigButtonCls(PropsButtonType, ButtonType)
    {
        let objCls = ""

        if (PropsButtonType === ButtonType)
        {
            objCls = cssToolBarBottomUnit.btnBigButtonSelected
        }
        else
        {
            objCls = cssToolBarBottomUnit.btnBigButton
        }

        return objCls
    } // end of GetBigButtonCls
    // #endregion Get ClassName

    // // #region Call App
    // /*===========================================
    // summary: 取得 字彙表資料 流程 開始
    // remarks: 000 Tim 2021/11/04 Create
    // ===========================================*/
    // function GetGlossaryFromAppProcessBegin (BookCategoryID)
    // {
    //     console.log(COMP_NAME + ".GetGlossaryFromAppProcessBegin ", BookCategoryID)

    //     window.ComponentFuncEntry.GlossaryRef = ComponentFuncEntry

    //     AppDataAccess.GetGlossaryFromApp(BookCategoryID)
    // } // end of GetGlossaryFromAppProcessBegin

    // /*===========================================
    // summary: 取得 字彙表資料 流程 結束
    // remarks: 000 Tim 2021/11/23 Create
    // ===========================================*/
    // function GetGlossaryFromAppProcessEnd (CallbackObject)
    // {        
    //     // let objLocationState = {
    //     //     "OriginalButtonType": props.ButtonType
    //     // }

    //     // RoutePathLibs.Route2Path(props.History, "/Glossary", objLocationState)

    //     if (
    //         (props.ButtonType === window.gButtonTypeEnum.Prelude) ||
    //         (props.ButtonType === window.gButtonTypeEnum.LearningUnit)
    //         )
    //     {
    //         if (
    //             (typeof(props.CallbackRef) !== 'undefined') &&
    //             (props.CallbackRef !== null)
    //             )
    //         {
    //             let objCallbackData = {
    //                 "Action": "OpenShowGlossary"
    //             }

    //             props.CallbackRef(objCallbackData)
    //         }
    //     }
    //     else
    //     {
    //         setIsShowGlossary(true)
    //     }
    // } // end of GetGlossaryFromAppProcessEnd
    // // #endregion Call App

    // #region Render元件
    /*===========================================
    summary: Help Button 顯示Component   
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentHelpButton()
    {
        return (
            <div className={cssToolBarBottomUnit.btnSmallButton} onClick={(event) => HelpOnTapHandler(event)}>
                <div className={cssToolBarBottomUnit.btnHelpIcon} />
                <div className={cssToolBarBottomUnit.btnSmallText}>
                    {window.gAppUI.LBL_Help}
                </div>
            </div>
        )
    } // end of ComponentHelpButton

    /*===========================================
    summary: Settings Button 顯示Component   
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentSettingsButton()
    {
        return (
            <div className={cssToolBarBottomUnit.btnSmallButton} onClick={(event) => SettingsOnTapHandler(event)}>
                <div className={cssToolBarBottomUnit.btnSettingsIcon} />
                <div className={cssToolBarBottomUnit.btnSmallText}>
                    {window.gAppUI.LBL_Settings}
                </div>
            </div>
        )
    } // end of ComponentSettingsButton

    /*===========================================
    summary: Glossary Button 顯示Component   
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentGlossaryButton()
    {
        return (
            <div className={cssToolBarBottomUnit.btnSmallButton} onClick={(event) => GlossaryOnTapHandler(event)}>
                <div className={cssToolBarBottomUnit.btnGlossaryIcon} />
                <div className={cssToolBarBottomUnit.btnSmallText}>
                    {window.gAppUI.LBL_Glossary}
                </div>
            </div>
        )
    } // end of ComponentGlossaryButton

    /*===========================================
    summary: NoteList Button 顯示Component   
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentNoteListButton()
    {
        return (
            <div className={cssToolBarBottomUnit.btnSmallButton} onClick={(event) => NoteListOnTapHandler(event)}>
                <div className={cssToolBarBottomUnit.btnNoteListIcon} />
                <div className={cssToolBarBottomUnit.btnSmallText}>
                    {window.gAppUI.LBL_NoteList}
                </div>
            </div>
        )
    } // end of ComponentNoteListButton

    /*===========================================
    summary: Resources Button 顯示Component   
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentResourcesButton()
    {
        return (
            <div className={cssToolBarBottomUnit.btnSmallButton} onClick={(event) => ResourcesOnTapHandler(event)}>
                <div className={cssToolBarBottomUnit.btnResourcesIcon} />
                <div className={cssToolBarBottomUnit.btnSmallText}>
                    {window.gAppUI.LBL_Resources}
                </div>
            </div>
        )
    } // end of ComponentResourcesButton                

    /*===========================================
    summary: BCApps Button 顯示Component   
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentBCAppsButton()
    {
        return (
            <div className={cssToolBarBottomUnit.btnBigButton} onClick={(event) => BCAppsOnTapHandler(event)}>
                <div className={cssToolBarBottomUnit.btnBCAppsIcon} />
                <div className={cssToolBarBottomUnit.btnBCAppsText}>
                    {window.gAppUI.LBL_BCApps}
                </div>
            </div>
        )
    } // end of ComponentBCAppsButton

    /*===========================================
    summary: Assessments Button 顯示Component   
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentAssessmentsButton()
    {
        return (
            <>
                <div className={cssToolBarBottomUnit.btnBigButton} onClick={(event) => AssessmentsOnTapHandler(event)}>
                    <div className={cssToolBarBottomUnit.btnAssessmentsIcon} />
                    <div className={cssToolBarBottomUnit.btnAssessmentsText}>
                        {window.gAppUI.LBL_Assessments}
                    </div>
                </div>

                <div className={cssToolBarBottomUnit.btnLine} />
            </>
        )
    } // end of ComponentAssessmentsButton

    /*===========================================
    summary: Lessons Button 顯示Component   
                目前按鈕是Lessons 才需要顯示 線
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentLessonsButton()
    {
        return (
            <>
                <div className={GetBigButtonCls(props.ButtonType, window.gButtonTypeEnum.Lessons)} onClick={(event) => LessonsOnTapHandler(event)}>
                    <div className={cssToolBarBottomUnit.btnLessonsIcon} />
                    <div className={cssToolBarBottomUnit.btnLessonsText}>
                        {window.gAppUI.LBL_Lessons}
                    </div>
                </div>

                <div className={GetLessonsLineCls(props.ButtonType)} />
            </>
        )
    } // end of ComponentLessonsButton

    /*===========================================
    summary: Home Button 顯示Component  
                目前按鈕是LearningUnit 才需要顯示 線
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentHomeButton()
    {
        return (
            <>
                <div className={GetBigButtonCls(props.ButtonType, window.gButtonTypeEnum.Home)} onClick={(event) => HomeOnTapHandler(event)}>
                    <div className={cssToolBarBottomUnit.btnHomeIcon} />
                    <div className={cssToolBarBottomUnit.btnHomeText}>
                        {window.gAppUI.LBL_Home}
                    </div>
                </div>

                <div className={GetHomeLineCls(props.ButtonType)} />
            </>
        )
    } // end of ComponentHomeButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 購買提示視窗 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderSettingsWrapper(StateIsShowSettings)
    {
        if (
            (mobjShowComponentParam !== null) &&
            (StateIsShowSettings)
            )
        {
            return (
                <Settings AuthorizedSubscription={mobjShowComponentParam.AuthorizedSubscription}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderSettingsWrapper

    /*===========================================
    summary: Render Note List 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderNoteListWrapper(StateIsShowNoteList)
    {
        if (StateIsShowNoteList)
        {
            return (
                <NoteList History={props.History}
                    ButtonType={props.ButtonType}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderNoteListWrapper

    /*===========================================
    summary: Render Glossary 的顯示
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function RenderGlossaryWrapper(StateIsShowGlossary)
    {
        if (StateIsShowGlossary)
        {
            return (
                <Glossary History={props.History}
                    ButtonType={props.ButtonType}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderGlossaryWrapper

    /*===========================================
    summary: Render 資源下載視窗 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderResourceWrapper(StateIsShowResource)
    {
        if (StateIsShowResource)
        {
            return (
                <Resource CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderResourceWrapper

    /*===========================================
    summary: Render 右邊區塊 功能按鈕
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderRightWrapper()
    {
        return (
            <div className={cssToolBarBottomUnit.divRightMain}>
                <ComponentResourcesButton />

                <ComponentNoteListButton />

                <ComponentGlossaryButton />

                <ComponentSettingsButton />

                <ComponentHelpButton />
            </div>
        )
    } // end of RenderRightWrapper

    /*===========================================
    summary: Render 左邊區域 大按鈕 
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function RenderLeftWrapper()
    {
        return (
            <div className={cssToolBarBottomUnit.divLeftMain}>
                <ComponentHomeButton />

                <ComponentLessonsButton />

                <ComponentAssessmentsButton />

                <ComponentBCAppsButton />
            </div>
        )
    } // end of RenderLeftWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                {RenderLeftWrapper()}

                {RenderRightWrapper()}
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssToolBarBottomUnit.divMain}>
                {RenderContentWrapper()}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}

            {RenderResourceWrapper(isShowResource)}
            {RenderNoteListWrapper(isShowNoteList)}
            {RenderGlossaryWrapper(isShowGlossary)}
            {RenderSettingsWrapper(isShowSettings)}
        </>
    )
    // #endregion Render
}
export default ToolBarBottomUnit